import * as Scrivito from "scrivito";

const Quote = Scrivito.provideObjClass("Quote", {
  attributes: {
    title: "string",
    image: ["reference", { only: ["Image"] }],
    content: "html",
    author: "string",
    function: "string",
  },
});

export default Quote;
